import { createTheme } from '@mui/material/styles';

const blackYellowTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#f5d300', // Yellow
      light: '#fff44f',
      dark: '#e5c300',
      contrastText: '#111111',
    },
    secondary: {
      main: '#e5c300', // Darker yellow
      light: '#ffcd45',
      dark: '#b59a00',
      contrastText: '#111111',
    },
    background: {
      default: '#111111', // Black
      paper: '#1a1a1a',
    },
    text: {
      primary: '#ffffff',
      secondary: '#f5d300',
    },
    error: {
      main: '#ff3d00',
    },
    warning: {
      main: '#ffa000',
    },
    info: {
      main: '#29b6f6',
    },
    success: {
      main: '#66bb6a',
    },
    divider: '#333333',
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      color: '#f5d300',
    },
    h2: {
      color: '#f5d300',
    },
    h3: {
      color: '#f5d300',
    },
    h4: {
      color: '#f5d300',
    },
    h5: {
      color: '#f5d300',
    },
    h6: {
      color: '#f5d300',
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#1a1a1a',
          borderBottom: '2px solid #f5d300',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#1a1a1a',
          color: '#ffffff',
          border: '1px solid #333333',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          backgroundColor: '#f5d300',
          color: '#111111',
          '&:hover': {
            backgroundColor: '#e5c300',
          },
        },
        outlinedPrimary: {
          color: '#f5d300',
          borderColor: '#f5d300',
          '&:hover': {
            backgroundColor: 'rgba(245, 211, 0, 0.1)',
            borderColor: '#f5d300',
          },
        },
        textPrimary: {
          color: '#f5d300',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            color: '#f5d300',
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: '#f5d300',
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        standardSuccess: {
          backgroundColor: 'rgba(76, 175, 80, 0.2)',
          color: '#81c784',
        },
        standardWarning: {
          backgroundColor: 'rgba(255, 152, 0, 0.2)',
          color: '#ffb74d', 
        },
        standardError: {
          backgroundColor: 'rgba(211, 47, 47, 0.2)',
          color: '#e57373',
        },
        standardInfo: {
          backgroundColor: 'rgba(2, 136, 209, 0.2)',
          color: '#4fc3f7',
        },
      },
    },
  },
});

export default blackYellowTheme;